(function () {
  function directChildrenTrack(section) {
    return section.querySelector(
      '.section-content-wrapper > .group-block > .group-block-content'
    );
  }

  function initRatingScroller(section) {
    if (!section || section.dataset.sisiyuyuRatingUi === 'ready') return;

    var track = directChildrenTrack(section);
    if (!track) return;

    var cards = Array.prototype.slice.call(track.children).filter(function (child) {
      return child.classList.contains('group-block');
    });
    if (cards.length < 2) return;

    section.dataset.sisiyuyuRatingUi = 'ready';

    var controls = document.createElement('div');
    controls.className = 'gn-rating-controls';

    var dots = document.createElement('div');
    dots.className = 'gn-rating-dots';
    dots.setAttribute('aria-hidden', 'true');

    cards.forEach(function (_, index) {
      var dot = document.createElement('span');
      dot.className = 'gn-rating-dot' + (index === 0 ? ' is-active' : '');
      dot.dataset.index = String(index);
      dots.appendChild(dot);
    });

    var previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'gn-rating-prev';
    previous.setAttribute('aria-label', 'Previous review platform');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'gn-rating-next';
    next.setAttribute('aria-label', 'Next review platform');

    controls.appendChild(dots);
    controls.appendChild(previous);
    controls.appendChild(next);
    section.appendChild(controls);

    function nearestIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCenter - center);
        if (distance < closestDistance) {
          closest = index;
          closestDistance = distance;
        }
      });

      return closest;
    }

    function scrollToIndex(index) {
      var target = cards[index];
      if (!target) return;

      track.scrollTo({
        left: target.offsetLeft - Math.max(0, (track.clientWidth - target.offsetWidth) / 2),
        behavior: 'smooth',
      });
    }

    previous.addEventListener('click', function () {
      scrollToIndex((nearestIndex() - 1 + cards.length) % cards.length);
    });

    next.addEventListener('click', function () {
      var current = nearestIndex();
      scrollToIndex((current + 1) % cards.length);
    });

    track.addEventListener('scroll', function () {
      var current = nearestIndex();
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        dot.classList.toggle('is-active', index === current);
      });
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[id$="__gn1_ratings"]').forEach(initRatingScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
